module.exports = __webpack_public_path__ + "static/media/React-Native-Expo.3290abd7.jpg";